import { Injectable } from '@angular/core';
import { MedicoDTO } from 'app/model/dtos/grl/medico.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';

@Injectable()
export class MedicoController {

    constructor() { }
    
    async find(filtros?:IFilter):Promise<Array<MedicoDTO>>{	
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/medicos',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<MedicoDTO>()
			)
		);
		return await quark.call();
	}

	async get(cdPessoa:number):Promise<MedicoDTO>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: `grl/medicos/:cdPessoa`,
					environment: environment,
					pathParams: new JSONData({cdPessoa: cdPessoa})
				}),
			}),
			new HttpResponse(
				new MedicoDTO()
			)
        );
        return await quark.call();
	}

	async create(medico: MedicoDTO):Promise<MedicoDTO>{
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/medicos',
					environment: environment
				}),
				data: new JSONData(medico)
			}),
			new HttpResponse(
				new MedicoDTO()
			)
		);
		return await quark.call();
	}

	async update(medico: MedicoDTO):Promise<MedicoDTO>{
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'grl/medicos/:cdPessoa', 
					environment: environment, 
					pathParams: new JSONData({cdPessoa: medico.cdPessoa})
				}),
				data: new JSONData(medico)
			}),
			new HttpResponse(
				new MedicoDTO()
			)
		);
		return await quark.call();
	}

}